export default __webpack_public_path__ + "static/media/icon-en.da47ce2f.svg";